import { render, staticRenderFns } from "./Signin.vue?vue&type=template&id=dca50b72&scoped=true&"
import script from "./Signin.vue?vue&type=script&lang=js&"
export * from "./Signin.vue?vue&type=script&lang=js&"
import style0 from "./Signin.vue?vue&type=style&index=0&id=dca50b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca50b72",
  null
  
)

export default component.exports